import icNorank from '@/images/music-recap/ic_norank.png'
import icMusicgod from '@/images/music-recap/Musicgod.png'
import icSongLegend from '@/images/music-recap/SongLegend.png'
import icMP3Hero from '@/images/music-recap/MP3Hero.png'
import icMusicLover from '@/images/music-recap/MusicLover.png'
import icRhythmApprentice from '@/images/music-recap/RhythmApprentice.png'
import icMusicNovice from '@/images/music-recap/MusicNovice.png'

export const icLevelList = [
  icNorank,
  icMusicgod,
  icMusicgod,
  icMusicgod,
  icMusicgod,
  icSongLegend,
  icMP3Hero,
  icMP3Hero,
  icMusicLover,
  icMusicLover,
  icRhythmApprentice,
  icMusicNovice,
]

export const HELP_URL = 'https://forms.gle/jNe8Xh5Nx1v92htK7'
export const GP_LP_URL =
  'https://play.google.com/store/apps/details?id=com.dywx.larkplayer'

export const rg = {
  en: 'en-US',
  es: 'es-MX',
  pt: 'pt-BR',
}

export const monthList = [
  '一月',
  '二月',
  '三月',
  '四月',
  '五月',
  '六月',
  '七月',
  '八月',
  '九月',
  '十月',
  '十一月',
  '十二月',
]

// 时间段
export const periodList = [
  ['05:00:00', '10:59:59'],
  ['11:00:00', '13:59:59'],
  ['14:00:00', '17:59:59'],
  ['18:00:00', '19:59:59'],
  ['20:00:00', '23:59:59'],
  ['00:00:00', '04:59:59'],
]
export const periods = [
  '早晨 (5am-11am)',
  '午间 (11am-2pm)',
  '下午 (2pm-6pm)',
  '傍晚 (6pm-8pm)',
  '夜间 (8pm-0am)',
  '凌晨 (0am-5am)',
]
export const periodTexts = [
  'in the morning',
  'at noon',
  'in the afternoon',
  'in the evening',
  'at night',
  'at late night',
]

// 排名
export const rankRange = [
  '',
  '<=1%',
  '>1% & <=2%',
  '>2% & <=3%',
  '<=5%',
  '>5% & <=10%',
  '>10% & <=20%',
  '>20% & <=30%',
  '>30% & <=40%',
  '>40% & <=50%',
  '>50% & <=70%',
  '>70%',
]

export const rankRange1 = [
  '',
  '<=1%',
  '>1% & <=2%',
  '>2% & <=3%',
  '<=5%',
  '>5% & <=10%',
  '>10% & <=20%',
  '>20% & <=30%',
  '>30% & <=40%',
  '>40% & <=50%',
  '>50% & <=70%1',
  '>70%1',
]

export const rankLevel = [
  '拿不到数据时',
  'Music God',
  'Music God',
  'Music God',
  'Music God',
  'Song Legend',
  'MP3 Hero',
  'MP3 Hero',
  'Music Lover',
  'Music Lover',
  'Rhythm Apprentice',
  'Music Novice',
]

export const regionList = [
  'MX',
  'EG',
  'BR',
  'IQ',
  'CO',
  'AR',
  'VE',
  'IN',
  'MA',
  'EC',
  'DZ',
  'PE',
  'BO',
  'GT',
  'SY',
  'NI',
  'BD',
  'US',
  'YE',
  'DO',
  'TN',
  'HN',
  'PK',
  'CU',
  'SA',
  'SV',
  'CL',
  'SD',
  'PY',
  'KE',
  'JO',
  'IL',
  'PH',
  'HT',
  'CR',
  'LB',
  'AE',
  'PA',
  'BR',
  'FR',
  'LY',
  'ZA',
  'ES',
  'TZ',
  'SD',
  'MG',
  'SY',
  'ZM',
  'CI',
  'UG',
  'UY',
  'CD',
  'ZW',
  'NG',
  'ET',
  'NP',
  'OM',
  'IL',
  'RW',
  'CM',
  'SN',
  'MZ',
  'SR',
  'GY',
  'AO',
  'SS',
  'GA',
  'JM',
  'GH',
  'QA',
]

// 月报覆盖128个国家
export const monthlyRegionList = [
  'BR',
  'MX',
  'EG',
  'IQ',
  'CO',
  'AR',
  'VE',
  'IN',
  'MA',
  'EC',
  'DZ',
  'PE',
  'BO',
  'GT',
  'SY',
  'NI',
  'BD',
  'US',
  'YE',
  'DO',
  'TN',
  'HN',
  'PK',
  'CU',
  'SA',
  'SV',
  'CL',
  'SD',
  'PY',
  'KE',
  'JO',
  'PS',
  'PH',
  'HT',
  'CR',
  'LB',
  'AE',
  'PA',
  'CA',
  'FR',
  'LY',
  'ZA',
  'ES',
  'TZ',
  'MW',
  'MG',
  'GB',
  'ZM',
  'CI',
  'UG',
  'UY',
  'CD',
  'ZW',
  'NG',
  'ET',
  'NP',
  'OM',
  'IL',
  'RW',
  'CM',
  'SN',
  'MZ',
  'SR',
  'GY',
  'AO',
  'SS',
  'GA',
  'JM',
  'GH',
  'QA',
  'SG',
  'CV',
  'AU',
  'NC',
  'BW',
  'PT',
  'BE',
  'PF',
  'BF',
  'KW',
  'BZ',
  'TT',
  'ML',
  'TG',
  'NA',
  'BI',
  'TD',
  'GN',
  'CH',
  'RE',
  'GF',
  'BB',
  'PG',
  'FJ',
  'IE',
  'BH',
  'YT',
  'GW',
  'DM',
  'LS',
  'NE',
  'GP',
  'LU',
  'DJ',
  'SZ',
  'SL',
  'AG',
  'KM',
  'MQ',
  'GD',
  'LR',
  'SB',
  'CF',
  'SC',
  'VU',
  'MT',
  'TL',
  'WF',
  'TO',
  'MF',
  'WS',
  'KI',
  'NR',
  'PW',
  'MH',
  'MC',
  'TV',
  'PR',
  'CN',
  'HK',
]

export const arRegionList = [
  'EG',
  'IQ',
  'MA',
  'DZ',
  'SY',
  'YE',
  'TN',
  'SA',
  'SD',
  'JO',
  'PS',
  'LB',
  'AE',
  'LY',
  'OM',
  'IL',
  'QA',
]

export const rtlLangList = ['ar', 'fa', 'he', 'ur', 'pa-PK']
